// extracted by mini-css-extract-plugin
export default {"Education":"Education_Education__CWotA","Education__showcase":"Education_Education__showcase__+w2G3"};